// The Calculate mark, on its own so the project page can draw it without
// loading Calculate (which is lazy: only its pilot users ever open it).
//
// BRAND (design screen 16, export brand/calculate/, 15/10/2026): a blue tile
// with one rounded corner, two white bars and the orange dot. The files are
// in public/brand/calculate/ (icon, reversed icon, wordmark, lock-up, PNGs);
// the mark is drawn inline here so it follows the theme tokens, and the
// wordmark is live Suisse text as the lock-up file sets it. The README says
// the wordmark and icon are a first proposal awaiting sign-off: this file is
// the one place to swap them.

/** The icon: the tile from brand/calculate/calculate-icon.svg, in tokens. */
export function calcIcon(size = 20) {
  return `<svg width="${size}" height="${size}" viewBox="0 0 64 64" aria-hidden="true" style="flex:0 0 ${size}px">
    <path d="M0 0 H42 A22 22 0 0 1 64 22 V64 H0 Z" fill="var(--cx-brand, var(--link))"/>
    <rect x="14" y="24" width="30" height="6" fill="#FFFFFF"/>
    <rect x="14" y="36" width="30" height="6" fill="#FFFFFF"/>
    <circle cx="51" cy="51" r="4" fill="var(--cx-attn, var(--brand-orange))"/>
  </svg>`;
}

/** The lock-up (brand/calculate/calculate-lockup.svg): icon, wordmark, "BY ASP · INSIDE TRACK". */
export function calcLockup({ size = 22 } = {}) {
  return `<span class="cx-lockup">${calcIcon(size)}<span class="cx-lockup-text"><span class="cx-lockup-word">Calculate</span><span class="cx-lockup-by">By ASP · inside Track</span></span></span>`;
}

/** Open Calculate from a screen with no selectView (the project page): the
 *  same path the Back button takes, so the URL, rail and history agree. */
export function goToCalculate(detail) {
  goToView('calculate', detail);
}

/** Open any Track view the same way (the shell's "Eng. review" opens the Calculate audit). */
export function goToView(view, detail = null) {
  const state = { view, detailId: detail || null };
  history.pushState(state, '', '/' + encodeURIComponent(view) + (detail ? '/' + encodeURIComponent(detail) : ''));
  window.dispatchEvent(new PopStateEvent('popstate', { state }));
}
